var map = {
	"./ch.json": 619,
	"./de.json": 620,
	"./en.json": 621,
	"./int.json": 622,
	"./uk.json": 623
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 618;


//////////////////
// WEBPACK FOOTER
// ./src/public/translations ^\.\/.*\.json$
// module id = 618
// module chunks = 0